import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { IRequestOptions } from '@monorepo/tools/src/lib/interfaces/url';
import { DomainFactorModel, IDomainFactorCreateForm, IDomainFactorEditForm } from '../models/domain-factor.model';

export const DomainFactorsApi = {
	list: async (params?: URLSearchParams): Promise<DomainFactorModel[]> => {
		return ask.get(endpoints.domainFactors.list(), params);
	},

	getByDomain: async (domain: string) => {
		return ask.get(endpoints.domainFactors.getByDomain(domain));
	},

	getByCampaign: async (campaignId: id) => {
		return ask.get(endpoints.domainFactors.getByCampaign(campaignId));
	},

	create: async (domainFactor: IDomainFactorCreateForm, options?: IRequestOptions): Promise<{ id: id }> => {
		return ask.post<IDomainFactorCreateForm[]>(endpoints.domainFactors.create(), [domainFactor], options);
	},

	get: async (id: id, options?: URLSearchParams): Promise<DomainFactorModel> => {
		return ask.get(endpoints.domainFactors.get(id), options);
	},

	edit: async (domainFactor: IDomainFactorEditForm, options?: IRequestOptions): Promise<null> => {
		return ask.post<IDomainFactorEditForm[]>(endpoints.domainFactors.edit(), [domainFactor], options);
	},

	delete: async (id: id | id[]): Promise<null> => {
		const ids = Array.isArray(id) ? id : [id];
		return ask.delete(endpoints.domainFactors.delete(), {
			body: ids,
			headers: { 'Content-Type': 'application/json' },
		});
	},
};
